module.exports = __webpack_public_path__ + "img/zhanggh.6e349990.jpg";